<div *ngIf="acessoLiberado">
  <div id="telaDeOcorrencias" class="container-fluid">
    <main-header></main-header>
    <main-container class="conteudo"></main-container>  
  </div>
    <box-graphic-statistic></box-graphic-statistic>
    <box-info-ocurrence></box-info-ocurrence>
    <popup-ocorrencia></popup-ocorrencia>
    <popup-config></popup-config>
    <popup-nova-ocorrencia></popup-nova-ocorrencia>
</div>